// Rolex Consent Bridge: synchronizes tarteaucitron consent state to the
// Rolex-required cookies (rlx-consent, rlx-marketing).
window.RolexConsentBridge = window.RolexConsentBridge || (function () {
    'use strict';

    var COOKIE_MAX_AGE = 31536000; // 365 days
    var COOKIE_PATH = '/';

    function getCookieValue(name) {
        var escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        var match = document.cookie.match(new RegExp('(?:^|; )' + escapedName + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    }

    function setCookieValue(name, value) {
        if (value !== 'true' && value !== 'false') {
            value = 'false';
        }

        document.cookie =
            encodeURIComponent(name) + '=' + encodeURIComponent(value) +
            '; path=' + COOKIE_PATH +
            '; max-age=' + COOKIE_MAX_AGE +
            '; SameSite=Lax' +
            (location.protocol === 'https:' ? '; Secure' : '');

        try {
            window.dispatchEvent(new CustomEvent('rolexConsentChanged', {
                detail: {
                    cookie: name,
                    value: value,
                    analyticsAllowed: getCookieValue('rlx-consent') === 'true',
                    marketingAllowed: getCookieValue('rlx-marketing') === 'true'
                }
            }));
        } catch (error) {
            // CustomEvent unavailable: the consent cookie is still written.
        }
    }

    function ensureDefaults() {
        if (getCookieValue('rlx-consent') !== 'true' && getCookieValue('rlx-consent') !== 'false') {
            setCookieValue('rlx-consent', 'false');
        }

        if (getCookieValue('rlx-marketing') !== 'true' && getCookieValue('rlx-marketing') !== 'false') {
            setCookieValue('rlx-marketing', 'false');
        }
    }

    function analyticsAllowed() {
        return getCookieValue('rlx-consent') === 'true';
    }

    function marketingAllowed() {
        return getCookieValue('rlx-marketing') === 'true';
    }

    return {
        get: getCookieValue,
        set: setCookieValue,
        ensureDefaults: ensureDefaults,
        analyticsAllowed: analyticsAllowed,
        marketingAllowed: marketingAllowed
    };
}());

// Missing Rolex cookies must be treated (and stored) as false.
window.RolexConsentBridge.ensureDefaults();

// Function to get the value of a cookie (kept global for theme scripts)
const getCookie = (name) => window.RolexConsentBridge.get(name);
window.getCookie = getCookie;

// Rolex Adobe Launch production tag. Staging/preview environments must use
// the Rolex staging tag instead of this URL.
const ADOBE_LAUNCH_SRC = "//assets.adobedtm.com/7e3b3fa0902e/7ba12da1470f/launch-5de25e657d80.min.js";
let adobeScriptRequested = false;
let adobeScriptLoaded = false;

// Function to load the Adobe script. Hard-gated by rlx-consent=true and
// idempotent so the tag can never be injected twice.
const loadAdobeScript = () => {
    if (adobeScriptLoaded || !window.RolexConsentBridge.analyticsAllowed()) {
        return;
    }
    adobeScriptLoaded = true;
    const adobeScript = document.createElement('script');
    adobeScript.src = ADOBE_LAUNCH_SRC;
    adobeScript.async = true;
    document.head.appendChild(adobeScript);
};
window.loadAdobeScript = loadAdobeScript;

// Called by Rolex page templates only. Loads Adobe Launch immediately when
// analytics consent already exists, otherwise waits for the user to grant
// analytics consent during the same visit.
const maybeLoadAdobeScript = () => {
    adobeScriptRequested = true;
    if (window.RolexConsentBridge.analyticsAllowed()) {
        loadAdobeScript();
    }
};
window.maybeLoadAdobeScript = maybeLoadAdobeScript;

window.addEventListener('rolexConsentChanged', (event) => {
    if (adobeScriptRequested && event.detail && event.detail.analyticsAllowed) {
        loadAdobeScript();
    }
});

// Consent-guarded Rolex tracking helper. Returns true only when the event
// actually fired. Never throws when tarteaucitron/_satellite are unavailable.
window.rolexTrack = (eventName) => {
    try {
        if (
            window.RolexConsentBridge &&
            window.RolexConsentBridge.analyticsAllowed() &&
            window._satellite &&
            typeof window._satellite.track === 'function'
        ) {
            window._satellite.track(eventName);
            return true;
        }
    } catch (error) {
        console.error('Rolex tracking failed:', error);
    }
    return false;
};

// Sync tarteaucitron stored choices with Rolex cookies (subsequent visits,
// or if tarteaucitron fails to load on this page view).
const syncConsentWithTarteaucitron = () => {
    const tacCookie = getCookie('shopify-cookies-consent');
    if (!tacCookie) {
        return;
    }

    const syncService = (serviceKey, rolexCookie) => {
        const match = tacCookie.match(new RegExp(serviceKey + '=(true|false)'));
        if (match && getCookie(rolexCookie) !== match[1]) {
            window.RolexConsentBridge.set(rolexCookie, match[1]);
        }
    };

    syncService('adobetracking', 'rlx-consent');
    syncService('rolexmarketing', 'rlx-marketing');
};

document.addEventListener('DOMContentLoaded', syncConsentWithTarteaucitron);

// tarteaucitron service events (safety net so tarteaucitron service state and
// Rolex cookie state can never diverge). Setter writes are idempotent.
document.addEventListener('adobetracking_allowed', () => {
    window.RolexConsentBridge.set('rlx-consent', 'true');
});
document.addEventListener('adobetracking_disallowed', () => {
    window.RolexConsentBridge.set('rlx-consent', 'false');
});
document.addEventListener('rolexmarketing_allowed', () => {
    window.RolexConsentBridge.set('rlx-marketing', 'true');
});
document.addEventListener('rolexmarketing_disallowed', () => {
    window.RolexConsentBridge.set('rlx-marketing', 'false');
});

// Always load the Tarteaucitron script
const loadTarteaucitronScript = () => {
    const script = document.createElement('script');
    script.src = "https://cdnjs.cloudflare.com/ajax/libs/tarteaucitronjs/1.19.0/tarteaucitron.js";
    script.integrity = "sha512-rVB1I2mKTuNzXSpRihvpiThlIPCJ0O5mywAtlKOV9VR5lnaffr5CZbpxxMcD/uxabzHl+nocgsPRPdeux0ED3Q==";
    script.crossOrigin = "anonymous";
    script.referrerPolicy = "no-referrer";
    script.async = true;

    script.onload = () => {
        tarteaucitronCustomText = {
            "acceptAll": "Accept All",
            "denyAll": "Deny All",
            "analytic": {
                "title": "Analytics & Statistics",
                "details": "The analytics & statistics services used to generate useful statistics attendance to improve the site."
            },
            "ads": {
                "title": "Marketing & Targeting",
                "details": "The marketing & targeting services used to measure the effectiveness of advertising and provide relevant content."
            },
            "mandatoryTitle": "Essential",
            "mandatoryText": "This site uses some cookies necessary for its proper functioning which cannot be deactivated.",
        };

        // Analytics / Statistics / Performance service -> rlx-consent
        tarteaucitron.services.adobetracking = {
            "key": "adobetracking",
            "type": "analytic",
            "name": "Adobe Analytics Tracking",
            "needConsent": true,
            "cookies": ['rlx-consent'],
            "readmoreLink": "https://www.rolex.com/en-us/legal-notices/cookies",
            "url": null,
            "js": function () {
                window.RolexConsentBridge.set('rlx-consent', 'true');
            },
            "fallback": function () {
                window.RolexConsentBridge.set('rlx-consent', 'false');
            },
        };

        // Marketing / Targeting / Advertising service -> rlx-marketing
        tarteaucitron.services.rolexmarketing = {
            "key": "rolexmarketing",
            "type": "ads",
            "name": "Rolex Marketing",
            "needConsent": true,
            "cookies": ['rlx-marketing'],
            "readmoreLink": "https://www.rolex.com/en-us/legal-notices/cookies",
            "url": null,
            "js": function () {
                window.RolexConsentBridge.set('rlx-marketing', 'true');
            },
            "fallback": function () {
                window.RolexConsentBridge.set('rlx-marketing', 'false');
            },
        };

        tarteaucitron.init({
            privacyUrl: '/pages/privacy-policy',
            cookieName: 'shopify-cookies-consent',
            orientation: 'bottom',
            groupServices: true,
            showDetailsOnClick: true,
            highPrivacy: true,
            serviceDefaultState: 'wait',
            DenyAllCta: true,
            AcceptAllCta: true,
            mandatory: true,
            mandatoryCta: true,
            showIcon: false,
            iconPosition: 'BottomRight',
            removeCredit: true,
            moreInfoLink: false,
            googleConsentMode: true,
        });

        // Override respond and respondAll so every same-session consent
        // change (granular or accept/deny all) updates the Rolex cookies.
        const originalRespond = tarteaucitron.respond;
        const originalRespondAll = tarteaucitron.respondAll;

        tarteaucitron.respond = function (el, status) {
            if (typeof originalRespond === 'function') {
                originalRespond(el, status);
            }
            if (el && el.id) {
                if (el.id.includes('adobetracking')) {
                    window.RolexConsentBridge.set('rlx-consent', status ? 'true' : 'false');
                }
                if (el.id.includes('rolexmarketing')) {
                    window.RolexConsentBridge.set('rlx-marketing', status ? 'true' : 'false');
                }
            }
        };

        tarteaucitron.respondAll = function (status, type, allowSafeAnalytics) {
            if (typeof originalRespondAll === 'function') {
                originalRespondAll(status, type, allowSafeAnalytics);
            }
            if (!type || type === 'analytic') {
                window.RolexConsentBridge.set('rlx-consent', status ? 'true' : 'false');
            }
            if (!type || type === 'ads') {
                window.RolexConsentBridge.set('rlx-marketing', status ? 'true' : 'false');
            }
        };

        // Register services
        tarteaucitron.job = tarteaucitron.job || [];
        tarteaucitron.job.push('adobetracking', 'rolexmarketing', 'gcmadstorage', 'gcmanalyticsstorage', 'gcmfunctionality', 'gcmadsuserdata', 'gcmsecurity');
    };

    document.head.appendChild(script);
};

// Load Tarteaucitron
loadTarteaucitronScript();
